/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvc2hhcmVkL3NuYWNrLW1lc3NhZ2VzL3NuYWNrLW1lc3NhZ2Uvc25hY2stbWVzc2FnZS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvY2hyb25vY2FzaFYzL3Rlc3Qvd2ViYXBwLWNsay9zcmMvYXBwL3NoYXJlZC9zbmFjay1tZXNzYWdlcy9zbmFjay1tZXNzYWdlL3NuYWNrLW1lc3NhZ2UuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/snack-messages/snack-message/snack-message.component.scss.shim.ngstyle.ts